export default class UserService {

    constructor({
        accountNumber = 0,
        billingId = 0,
        id = 0,
        ipGroup = null,
        isRadiusActive = "y",
        kayakoConversation = null,
        lineStatus = null,
        masterServiceId = 0,
        radiusAccountId = 0,
        radiusGarden = null,
        radiusPassword = null,
        radiusServiceId = 0,
        radiusShape = null,
        radiusStaticIp = null,
        radiusUsername = null,
        supplierBillingReference = null,
        ratePlanId = 1297,
        serviceId = null,
        serviceStreet = null,
        serviceCity = null,
        serviceName = null,

        company = null,
        isDeleted = false,
        nbnServiceType = null,
        password = null,
        serviceAddress = null,
        serviceDescription = null,
        status = null,
        userService = 0,
        username = null,

        sellToUB = false,
        ipRange = null,
        isIPoE = false,


    } = {}){
        this.accountNumber = accountNumber,
        this.billingId = billingId,
        this.id = id,
        this.ipGroup = ipGroup,
        this.isRadiusActive = isRadiusActive,
        this.kayakoConversation = kayakoConversation,
        this.lineStatus = lineStatus,
        this.masterServiceId = masterServiceId,
        this.radiusAccountId = radiusAccountId,
        this.radiusGarden = radiusGarden,
        this.radiusPassword = radiusPassword ? radiusPassword : password,
        this.radiusServiceId = radiusServiceId,
        this.radiusShape = radiusShape,
        this.radiusStaticIp = radiusStaticIp,
        this.radiusUsername = radiusUsername ? radiusUsername : username,
        this.supplierBillingReference = supplierBillingReference,
        this.ratePlanId = ratePlanId,
        this.serviceId = serviceId,
        this.serviceStreet = serviceStreet ? serviceStreet : serviceAddress,
        this.serviceCity = serviceCity,

        this.company = company,
        this.isDeleted = isDeleted,
        this.nbnServiceType = nbnServiceType,
        this.password = password,
        this.serviceAddress = serviceAddress,
        this.serviceDescription = serviceDescription,
        this.serviceName = serviceName,
        this.status = status,
        this.userService = userService,
        this.username = username,

        this.sellToUB = sellToUB,
        this.ipRange = ipRange,
        this.isIPoE = isIPoE
    }

}
